module.exports = __webpack_public_path__ + "static/media/default-user.aa3e5d1f.png";